import { useState, useEffect } from "react";
import { getSectionContent } from "@/data/cmsStore";

export function useCmsSection(sectionId: string, page: string = "home") {
  const [content, setContent] = useState(() => getSectionContent(sectionId, page));

  useEffect(() => {
    const handleUpdate = (e: any) => {
      if (!e.detail || e.detail.page === page || e.detail.page === "all") {
        setContent(getSectionContent(sectionId, page));
      }
    };
    window.addEventListener("cmsLayoutDraftChanged", handleUpdate);
    window.addEventListener("cmsLayoutChanged", handleUpdate);
    return () => {
      window.removeEventListener("cmsLayoutDraftChanged", handleUpdate);
      window.removeEventListener("cmsLayoutChanged", handleUpdate);
    };
  }, [sectionId, page]);

  return content;
}
